"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _helpButton = _interopRequireDefault(require("../../../../core/help-button"));
var _daySummary = _interopRequireDefault(require("./day-summary"));
var _summaryHelp = _interopRequireDefault(require("./summary-help"));
var _createSignInSheet = _interopRequireDefault(require("./create-sign-in-sheet"));
var _simplySlalomExport = _interopRequireDefault(require("./simply-slalom-export"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "You do not have access to this page");
var _ref2 = /*#__PURE__*/_react.default.createElement(_helpButton.default, null, /*#__PURE__*/_react.default.createElement(_summaryHelp.default, null));
class EntriesSummary extends _react.Component {
  render() {
    const competition = this.props.competition;
    if (!competition.isAdministratedByUser) return _ref;
    return /*#__PURE__*/_react.default.createElement("div", null, _ref2, /*#__PURE__*/_react.default.createElement(_row.default, null, competition.competitionDays.map(day => /*#__PURE__*/_react.default.createElement(_daySummary.default, {
      competitionSlug: this.props.match.params.competitionSlug,
      yearID: this.props.match.params.yearID,
      key: day.id,
      day: day,
      entryStatusRefs: this.props.refCodes.filter(refCode => !refCode.isExpired)
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-12"
    }, /*#__PURE__*/_react.default.createElement(_simplySlalomExport.default, {
      competitionSlug: this.props.match.params.competitionSlug,
      yearID: this.props.match.params.yearID,
      competitionDays: this.props.competition.competitionDays
    }), /*#__PURE__*/_react.default.createElement(_createSignInSheet.default, {
      competition: this.props.competition
    })));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref3 = _mergeBqlQueries({
  isAdministratedByUser: true,
  competitionDays: _mergeBqlQueries(_mergeBqlQueries({
    id: true
  }, _daySummary.default.partialQueries.CompetitionDay), _simplySlalomExport.default.partialQueries.CompetitionDay)
}, _createSignInSheet.default.partialQueries.Competition);
var _ref4 = _mergeBqlQueries({
  isExpired: true
}, _daySummary.default.partialQueries.EntryStatusRefs);
var _default = exports.default = (0, _reactBicycle.connect)(EntriesSummary, props => ({
  ["competition(competitionSlug:" + JSON.stringify(props.match.params.competitionSlug) + ",yearID:" + JSON.stringify(+props.match.params.yearID) + ")"]: _ref3,
  "refCodes(codeType:\"entrystatus\")": _ref4
}));